import { WebRTC } from "../../libs/webRTC";
import { SignalingLeaveResponse } from "../../proto/SignalingLeave_pb";
import BaseHandler from "../BaseHandler";

export default class HandleSignalingLeaveResponse extends BaseHandler<SignalingLeaveResponse> {
  handle() {
    WebRTC.instance.close(false);
  }
}
